export default "__VITE_ASSET__DdIMzHRV__"